import { Disc, Github, Linkedin, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function FooterArchive() {
  const socials = [{
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "LinkedIn",
    icon: Linkedin,
    href: "#"
  }, {
    name: "GitHub",
    icon: Github,
    href: "#"
  }, {
    name: "YouTube",
    icon: Youtube,
    href: "#"
  }, {
    name: "Discord",
    icon: Disc,
    href: "#"
  }];
  const productLinks = [{
    label: "The Spotlight",
    href: "/TheSpotlightPage"
  }, {
    label: "Visual Archive",
    href: "/VisualArchivePage"
  }, {
    label: "The Ledger",
    href: "/TheLedgerPage"
  }, {
    label: "Representation",
    href: "/RepresentationPage"
  }, {
    label: "Showreel",
    href: "#"
  }];
  const companyLinks = [{
    label: "Biography",
    href: "/TheSpotlightPage"
  }, {
    label: "Film Credits",
    href: "/TheLedgerPage"
  }, {
    label: "Theater Credits",
    href: "/TheLedgerPage"
  }, {
    label: "Press Kit",
    href: "#"
  }, {
    label: "Inquiry",
    href: "/RepresentationPage"
  }];
  const resourceLinks = [{
    label: "Headshots",
    href: "/VisualArchivePage"
  }, {
    label: "Production Stills",
    href: "/VisualArchivePage"
  }, {
    label: "Casting Resume",
    href: "#"
  }, {
    label: "Physical Stats",
    href: "/TheSpotlightPage"
  }, {
    label: "Special Skills",
    href: "/TheSpotlightPage"
  }, {
    label: "IMDb Profile",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy",
    href: "#"
  }, {
    label: "Terms",
    href: "#"
  }, {
    label: "Security",
    href: "#"
  }, {
    label: "Cookies",
    href: "#"
  }];
  return <section data-section-id="65" id="footer-archive" className="bg-background text-foreground border-t border-border">
      <div className="mx-auto max-w-[1280px] px-6 pt-20 pb-8">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {}
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="mt-5 text-[15px] leading-relaxed text-muted-foreground max-w-[280px] font-default">
              Jordan Rivers: A cinematic presence for film, television, and the theatrical stage.
            </p>

            {}
            <div className="mt-6 flex items-center gap-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link data-index={i} key={social.name} to={social.href} aria-label={social.name} className="group inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-primary transition-colors duration-200">
                    <Icon className="h-5 w-5" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {}
            <div>
              <h3 className="font-mono text-xs uppercase tracking-widest text-primary font-semibold">
                Performance
              </h3>
              <ul className="mt-5 space-y-3">
                {productLinks.map((link, i) => <li data-index={i} key={link.label}>
                    <Link to={link.href} className="group relative inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                      <span className="absolute -left-3 opacity-0 -translate-x-2 text-primary group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200">
                        ›
                      </span>
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div>
              <h3 className="font-mono text-xs uppercase tracking-widest text-primary font-semibold">
                The Artist
              </h3>
              <ul className="mt-5 space-y-3">
                {companyLinks.map((link, i) => <li data-index={i} key={link.label}>
                    <Link to={link.href} className="group relative inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                      <span className="absolute -left-3 opacity-0 -translate-x-2 text-primary group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200">
                        ›
                      </span>
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div className="col-span-2 md:col-span-1">
              <h3 className="font-mono text-xs uppercase tracking-widest text-primary font-semibold">
                Materials
              </h3>
              <ul className="mt-5 space-y-3">
                {resourceLinks.map((link, i) => <li data-index={i} key={link.label}>
                    <Link to={link.href} className="group relative inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                      <span className="absolute -left-3 opacity-0 -translate-x-2 text-primary group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200">
                        ›
                      </span>
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border">
          <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            {}
            <p className="font-mono text-[13px] text-muted-foreground">
              © 2025 JORDAN RIVERS. All rights reserved.
            </p>

            {}
            <div className="flex flex-col-reverse gap-6 md:flex-row md:items-center md:gap-8">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-2 font-mono text-[13px] text-muted-foreground">
                {legalLinks.map((link, i) => <span data-index={i} key={link.label} className="inline-flex items-center">
                    <Link to={link.href} className="hover:text-foreground transition-colors duration-200">
                      {link.label}
                    </Link>
                    {i < legalLinks.length - 1 && <span className="mx-2 text-muted-foreground/60">·</span>}
                  </span>)}
              </div>

              {}
              <Button variant="outline" size="sm" className="h-8 px-3 rounded-md bg-card border-border hover:bg-accent font-mono text-[12px] text-muted-foreground hover:text-foreground">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full rounded-md bg-primary opacity-75 animate-ping"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-md bg-primary"></span>
                </span>
                Available for casting
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}